<template>
   <div class="p-4">
        <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-if="fileModaledit" :class="{show: fileModaledit}">
   <div class="cstm-modal medium fixed_medium">
       <div class="header">
          <h4>Edit {{ fileType }}</h4>
          <button @click.stop="closeModalEditFile" class="close-modal">&times;</button>
        </div>
             <form class="video_form border_btm p-4 vertical_scrollbar" style="max-height: calc(100vh - 100px); overflow-x: hidden; overflow-y: auto;">
          <div class="each_detail mb-4">
            <label>{{ fileType }} title</label>
            <vs-input
              v-model="contentPayload.name"
              class="w-full"
              type="text"
              :placeholder="`Enter ${fileType} title here `"
            />
          </div>
          <div class="each_detail mb-4">
            <label>{{ fileType }} description</label>
            <vs-textarea
              v-model="contentPayload.description"
              class="w-full mb-0"
              :placeholder="`Enter ${fileType} description here `"
            ></vs-textarea>
          </div>
            <div class="each_detail mb-4" v-if="fileType=='Note'">
            <label>{{ fileType }} Text</label>
            <vs-textarea
              v-model="contentPayload.text"
              class="w-full mb-0"
              :placeholder="`Enter ${fileType} text here `"
            ></vs-textarea>
          </div>
          <div class="each_detail mb-4" v-else>
            <label>Insert {{ fileType }} link</label>
            <div class="w-full">
              <vs-input
                v-model="file_link"
                class="w-full"
                type="text"
                :placeholder="`Enter your ${fileType} link here `"
              />
              <p class="text-center my-4">Or</p>
              <div
                style="max-width: 200px; height: 50px; margin: 0 auto;"
                class="image_preview_holder"
                v-if="fileType == 'Video'"
              >
                <div
                  class="
                    flex
                    justify-center
                    items-center
                    w-full
                    h-full
                  "
                >
                  <span style="font-size: 30px" class="material-icons-outlined"
                    >videocam</span
                  >
                  <h6 style="color: #808080" class="m-2">Browse Video</h6>
                </div>
                <input
                  type="file"
                  accept="video/mp4,video/x-m4v,video/*"
                  @change="previewVideo"
                />
              </div>
              <template v-if="fileType == 'Video' && preview_video">
                <h4 class="text-center my-4">Preview</h4>
                <video v-if="preview_video" :src="preview_video" style="display: block; width: 400px; margin: 10px auto;" controls>
                </video>
              </template>
              <div
                style="max-width: 200px; height: 50px; margin: 0 auto;"
                class="image_preview_holder"
                v-else-if="fileType == 'Audio'"
              >
                <div
                  class="
                    flex
                    justify-center
                    items-center
                    w-full
                    h-full
                  "
                >
                  <span style="font-size: 30px" class="material-icons-outlined"
                    >mic_none</span
                  >
                  <h6 style="color: #808080" class="m-2">
                    Browse {{ fileType }}
                  </h6>
                </div>
                <input type="file" accept="audio/*" @change="previewVideo" />
              </div>
              <template v-if="fileType == 'Audio' && preview_video">
                <h4 class="text-center my-4">Preview</h4>
                <audio v-if="preview_video" :src="preview_video" style="display: block; margin: 10px auto;" controls>
                </audio>
              </template>
              <div
                style="max-width: 200px; height: 50px; margin: 0 auto;"
                class="image_preview_holder"
                v-else-if="fileType == 'File'"
              >
                <div
                  class="
                    flex
                    justify-center
                    items-center
                    w-full
                    h-full
                  "
                >
                  <span style="font-size: 30px" class="material-icons-outlined"
                    >folder_special</span
                  >
                  <h6 style="color: #808080" class="m-2">
                    Browse {{ fileType }}
                  </h6>
                </div>
                <input type="file" accept="application/pdf" @change="previewVideo" />
              </div>
              <template v-if="fileType == 'File' && preview_video">
                <h4 class="text-center my-4">Preview</h4>
                <!-- <div style="word-break: break-all;">{{ preview_video }}</div> -->
                <div style="width:400px; margin: 10px auto;">
                  <pdf :src="preview_video"></pdf>
                </div>
                 
              </template>
            </div>
          </div>
           <vs-button class="block mx-auto mt-4" @click="createTopic()"
          >Save</vs-button
        >
        </form>
       
   </div>
        </div>
      </div>
</template>
<script>
import pdf from 'vue-pdf'
import { repository } from '@/mixins/repository'
import { UploadImage } from '@/api/common'
import { addFile } from '@/api/file'
export default {
  mixins: [repository],
  name: 'FileModalComponent',
  props: {
    fileModaledit: {
      default: false
    },
    fileType: {
      default: ''
    },
    content: {
      default: ''
    }
  },
  created () {
    this.getRepositoryId(3)
    console.log(this.content)
    this.contentPayload = this.content
    if (this.content.topic_type === 6) {
      this.contentPayload.text = this.content.text.content
    } else {
      this.preview_video = this.contentPayload.topicFiles[0].file.file_path
    }
    
  },
  components: {
    pdf
  },
  data () {
    return {
      selected: '',
      file_link: null,
      customer_id: localStorage.getItem('customer_id'),
      preview_video: null,
      contentPayload: {
        name: null,
        description: null,
        custom: 0,
        has_all_subject: false,
        status: true,
        is_visible: true,
        topic_type: null,
        files: null
      }
    }
  },
  methods: {
    closeModalEditFile () {
      this.$emit('closeModalEditFile', true)
    },
    exportToCourse () {
      this.$emit('exportToCourse', this.selected)
    },
    createTopic () {
      if (this.file_link) {
        this.getFileId()
      } else {
        console.log(this.fileType)
        if (this.fileType === 'Video') {
          this.contentPayload.topic_type = 1
        } else if (this.fileType === 'Audio') {
          this.contentPayload.topic_type = 2
        } else if (this.fileType === 'File') {
          this.contentPayload.topic_type = 5
        } else if (this.fileType === 'Note') {
          this.contentPayload.topic_type = 6
        }
        this.fileModaledit = false
        this.$emit('updateEachTopic', this.contentPayload)
        //this.setDefault()
      }
    },
    setDefault () {
      this.contentPayload.name = null
      this.contentPayload.description = null
      this.contentPayload.custom = 0
      this.contentPayload.has_all_subject = false
      this.contentPayload.status = false
      this.contentPayload.is_visible = false
      this.contentPayload.topic_type = null
      this.contentPayload.files = null
    },
    async previewVideo (event) {
      const input = event.target
      if (input.files) {
        const reader = new FileReader()
        reader.onload = e => {
          console.log(e.target)
          //this.preview_video = e.target.result
        }
        this.video = input.files[0]
        reader.readAsDataURL(input.files[0])

        const formData = new FormData()
        formData.append('files[]', input.files[0])

        console.log(formData)

        const data = await UploadImage(formData, this.customer_id)
        const cdn = data.data.data.cdn

        const file_name = data.data.data.files[0].file_name
        const file_path = data.data.data.files[0].file_path

        const raw = JSON.stringify({
          file_repository_id: this.repository_id,
          files: [
            {
              file_name,
              file_path: `${cdn}${file_path}`
            }
          ]
        })

        const file_id_payload = raw

        this.getUploadFiles(file_id_payload)
      }
    },
    async getUploadFiles (file_id_payload) {
      const res = await addFile(file_id_payload)
      this.preview_video = null
      this.contentPayload.files = res.data.data.files[0].files_id
      console.log(res.data.data.files)
      this.preview_video = res.data.data.files[0].file_path
      if (this.file_link) {
        this.file_link = null
        this.createTopic()
      }
      this.$vs.loading.close()
    },
    async getFileId () {
      const file_name = new Date()
      const file_path = this.file_link

      const raw = JSON.stringify({
        file_repository_id: this.repository_id,
        files: [
          {
            file_name,
            file_path
          }
        ]
      })

      const file_id_payload = raw

      this.getUploadFiles(file_id_payload, 'video')
    }
  }
}
</script>
